module.exports = __webpack_public_path__ + "static/media/ofvirkur.c51b9291.svg";